import {PortalComponentParameterModel} from "./portal-component-parameter.model";
import {LocalizeTaggedTemplateEntry} from "../internationalization/localize-tagged-template-entry";

export enum PortalComponentStatus {
  New ='New',
  Existing = 'Existing',
  Updated = 'Updated',
}

export interface PortalComponentModel {
  id: string;
  Name: string;
  Key?: string;
  Description?: string;
  Category?: string;
  Component?: string;
  Template?: string;
  Styles?: string;
  ServerScript?: string;
  params: PortalComponentParameterModel[];
  fieldOptions?: string[],
  componentGroup?: string;
  componentClass?: any;
  componentHash?: string;
  componentStatus?: PortalComponentStatus;
  localizeTaggedTemplates?: LocalizeTaggedTemplateEntry[];
}

